import React, { createContext, useState, useEffect } from "react";
import getWarehouses from "services/warehouses/getWarehouses";

const WarehouseContext = createContext();

export const WarehouseProvider = ({ children }) => {
  const [warehouses, setWarehouses] = useState([]);

  useEffect(() => {
    getWarehouses()
      .then((res) => {
        setWarehouses(res.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error("Error fetching warehouses:", err);
      });
  }, []);

  return (
    <WarehouseContext.Provider value={{ warehouses }}>
      {children}
    </WarehouseContext.Provider>
  );
};

export default WarehouseContext;
